import { createElement } from "react";
import React from "react";
import { defaultArg, map, unwrap, bind, orElse } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { useFeliz_React__React_useOptionalFetch_Static_5B82200F, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { single } from "../Api/Locations.fs.js";
import { adminContent, ByCell, dateTimeCell, Labels, EntityName } from "./Prelude.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { single as single_1 } from "../Api/Areas.fs.js";
import { single as single_2 } from "../Api/Modules.fs.js";
import { single as single_3 } from "../Api/Subsystems.fs.js";
import { single as single_4 } from "../Api/Systems.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Entity, DomainEntity, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { map as map_1, head, tail, length, isEmpty, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/Tags.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, Export, MoveLogically, MovePhysically, AssignEquipmentType, AssignCriticality, AssignCondition, AssignStatus, Update } from "../Modals/Tag.fs.js";
import { Components_UnDelete, Components_Delete, Components_ExportLabels, Components_ChangeAttributes, Components_ChangeLabels } from "../Modals/Modal.fs.js";
import { many as many_1 } from "../Api/Entities.fs.js";

function AreaName(areaNameInputProps) {
    const tag = areaNameInputProps.tag;
    const projectId = areaNameInputProps.projectId;
    const areaId = orElse(bind((l) => l.AreaId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((locationId) => single(projectId, locationId), tag.LocationId, [tag.LocationId]))), tag.AreaId);
    return createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(7, []),
        entityId: unwrap(areaId),
    });
}

function ModuleName(moduleNameInputProps) {
    const tag = moduleNameInputProps.tag;
    const projectId = moduleNameInputProps.projectId;
    const areaId = orElse(bind((l) => l.AreaId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((locationId) => single(projectId, locationId), tag.LocationId, [tag.LocationId]))), tag.AreaId);
    const moduleId = orElse(bind((l_1) => l_1.ModuleId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((areaId_1) => single_1(projectId, areaId_1), areaId, [areaId]))), tag.ModuleId);
    return createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(6, []),
        entityId: unwrap(moduleId),
    });
}

function FacilityName(facilityNameInputProps) {
    const tag = facilityNameInputProps.tag;
    const projectId = facilityNameInputProps.projectId;
    const areaId = orElse(bind((l) => l.AreaId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((locationId) => single(projectId, locationId), tag.LocationId, [tag.LocationId]))), tag.AreaId);
    const moduleId = orElse(bind((l_1) => l_1.ModuleId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((areaId_1) => single_1(projectId, areaId_1), areaId, [areaId]))), tag.ModuleId);
    const facilityId = orElse(bind((l_2) => l_2.FacilityId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((moduleId_1) => single_2(projectId, moduleId_1), moduleId, [moduleId]))), tag.FacilityId);
    return createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(3, []),
        entityId: unwrap(facilityId),
    });
}

function SystemName(systemNameInputProps) {
    const tag = systemNameInputProps.tag;
    const projectId = systemNameInputProps.projectId;
    const systemId = orElse(map((l) => l.SystemId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((subsystemId) => single_3(projectId, subsystemId), tag.SubsystemId, [tag.SubsystemId]))), tag.SystemId);
    return createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(1, []),
        entityId: unwrap(systemId),
    });
}

function ProductionUnitName(productionUnitNameInputProps) {
    const tag = productionUnitNameInputProps.tag;
    const projectId = productionUnitNameInputProps.projectId;
    const systemId = orElse(map((l) => l.SystemId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((subsystemId) => single_3(projectId, subsystemId), tag.SubsystemId, [tag.SubsystemId]))), tag.SystemId);
    const productionUnitId = orElse(bind((l_1) => l_1.ProductionUnitId, Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((systemId_1) => single_4(projectId, systemId_1), systemId, [systemId]))), tag.ProductionUnitId);
    return createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(13, []),
        entityId: unwrap(productionUnitId),
    });
}

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(detail) {
    if (isNullOrWhiteSpace(detail)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["detail", detail]]);
    }
}

function equipmentTypeParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["equipmentTypeId"]);
    }
    else {
        return new FSharpResult$2(0, [["equipmentTypeId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function locationParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["locationId"]);
    }
    else {
        return new FSharpResult$2(0, [["locationId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function areaParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["areaId"]);
    }
    else {
        return new FSharpResult$2(0, [["areaId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function moduleParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["moduleId"]);
    }
    else {
        return new FSharpResult$2(0, [["moduleId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function facilityParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["facilityId"]);
    }
    else {
        return new FSharpResult$2(0, [["facilityId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function subsystemParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["subsystemId"]);
    }
    else {
        return new FSharpResult$2(0, [["subsystemId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function systemParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["systemId"]);
    }
    else {
        return new FSharpResult$2(0, [["systemId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function productionUnitParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["productionUnitId"]);
    }
    else {
        return new FSharpResult$2(0, [["productionUnitId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["labels"]);
    }
    else {
        return new FSharpResult$2(0, [["labels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("status", "Status", undefined), new Column("condition", "Condition", undefined), new Column("criticality", "Criticality", undefined), new Column("equiptmentType", "Equipment Type", new FilterType(1, [projectId, new DomainEntities(10, []), empty(), equipmentTypeParam])), new Column("location", "Location", new FilterType(1, [projectId, new DomainEntities(8, []), empty(), locationParam])), new Column("area", "Area", new FilterType(1, [projectId, new DomainEntities(7, []), empty(), areaParam])), new Column("module", "Module", new FilterType(1, [projectId, new DomainEntities(6, []), empty(), moduleParam])), new Column("facility", "Facility", new FilterType(1, [projectId, new DomainEntities(3, []), empty(), facilityParam])), new Column("subsystem", "Subsystem", new FilterType(1, [projectId, new DomainEntities(2, []), empty(), subsystemParam])), new Column("system", "System", new FilterType(1, [projectId, new DomainEntities(1, []), empty(), systemParam])), new Column("productionUnit", "Production Unit", new FilterType(1, [projectId, new DomainEntities(13, []), empty(), productionUnitParam])), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(0, []), empty(), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("createdDate", "Created Date", undefined), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function rowRender(projectId, tag) {
    return new Row(tag.Id, ofArray([new Cell("name", tag.Name), new Cell("detail", tag.Detail), new Cell("status", defaultArg(map(toString, tag.Status), defaultOf())), new Cell("condition", defaultArg(map(toString, tag.Condition), defaultOf())), new Cell("criticality", defaultArg(map(toString, tag.Criticality), defaultOf())), new Cell("equiptmentType", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(10, []),
        entityId: unwrap(tag.EquipmentTypeId),
    })), new Cell("location", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(8, []),
        entityId: unwrap(tag.LocationId),
    })), new Cell("area", createElement(AreaName, {
        projectId: projectId,
        tag: tag,
    })), new Cell("module", createElement(ModuleName, {
        projectId: projectId,
        tag: tag,
    })), new Cell("facility", createElement(FacilityName, {
        projectId: projectId,
        tag: tag,
    })), new Cell("subsystem", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(2, []),
        entityId: unwrap(tag.SubsystemId),
    })), new Cell("system", createElement(SystemName, {
        projectId: projectId,
        tag: tag,
    })), new Cell("productionUnit", createElement(ProductionUnitName, {
        projectId: projectId,
        tag: tag,
    })), new Cell("labels", createElement(Labels, {
        labels: tag.Labels,
    })), new Cell("createdDate", defaultArg(map(dateTimeCell, tag.CreatedDate), defaultOf())), new Cell("lastModifiedOn", dateTimeCell(tag.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: tag.LastModifiedBy,
    }))]));
}

export function Tags(tagsInputProps) {
    let actions, tags, tags_1;
    const projectId = tagsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedTags = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    const filters = patternInput_4[0];
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Tags",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (tagParams) => many(projectId, empty(), tagParams),
        fetchCount: (tagParams_1) => count(projectId, tagParams_1),
        rowRender: (tag) => rowRender(projectId, tag),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedTags);
    const isMoreThan1 = length(selectedTags) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Condition"], ["onClick", (_arg_3) => {
        setAction("assignCondition");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Criticality"], ["onClick", (_arg_4) => {
        setAction("assignCriticality");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Status"], ["onClick", (_arg_5) => {
        setAction("assignStatus");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Equipment Type"], ["onClick", (_arg_6) => {
        setAction("assignEquipmentType");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Move Logically"], ["onClick", (_arg_7) => {
        setAction("moveLogically");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Move Physically"], ["onClick", (_arg_8) => {
        setAction("movePhysically");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_9) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Attributes"], ["onClick", (_arg_10) => {
        setAction("changeAttributes");
    }], ["disabled", isEmpty(selectedTags) ? true : showDeleted]]))))), delay(() => append(showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_11) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedTags)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_12) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedTags)]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export"], ["onClick", (_arg_13) => {
        setAction("export");
    }]]))))), delay(() => singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export Labels"], ["onClick", (_arg_14) => {
        setAction("exportLabels");
    }]]))))))))))))))))))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedTags) ? (isEmpty(tail(selectedTags)) ? createElement(Update, {
        projectId: projectId,
        tag: head(selectedTags),
        close: close,
    }) : undefined) : undefined) : ((actions === "assignStatus") ? createElement(AssignStatus, {
        projectId: projectId,
        tags: selectedTags,
        close: close,
    }) : ((actions === "assignCondition") ? createElement(AssignCondition, {
        projectId: projectId,
        tags: selectedTags,
        close: close,
    }) : ((actions === "assignCriticality") ? createElement(AssignCriticality, {
        projectId: projectId,
        tags: selectedTags,
        close: close,
    }) : ((actions === "assignEquipmentType") ? createElement(AssignEquipmentType, {
        projectId: projectId,
        tags: selectedTags,
        close: close,
    }) : ((actions === "movePhysically") ? createElement(MovePhysically, {
        projectId: projectId,
        tags: selectedTags,
        close: close,
    }) : ((actions === "moveLogically") ? createElement(MoveLogically, {
        projectId: projectId,
        tags: selectedTags,
        close: close,
    }) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map_1((tag_1) => [new DomainEntity(8, [tag_1]), tag_1.Labels], selectedTags),
        close: close,
    }) : ((actions === "changeAttributes") ? createElement(Components_ChangeAttributes, {
        projectId: projectId,
        entities: map_1((tag_2) => [new Entity(7, [tag_2]), tag_2.Attributes], selectedTags),
        close: close,
    }) : ((actions === "export") ? createElement(Export, {
        projectId: projectId,
        filters: filters,
        close: () => {
            close(false);
        },
    }) : ((actions === "exportLabels") ? createElement(Components_ExportLabels, {
        entityType: new DomainEntities(0, []),
        countApi: () => count(projectId, filters),
        fetchApi: (apiParams_1) => many_1(new DomainEntities(0, []), projectId, apiParams_1, filters),
        close: () => {
            close(false);
        },
    }) : ((actions === "delete") ? ((tags = map_1((Item) => (new DomainEntity(8, [Item])), selectedTags), createElement(Components_Delete, {
        projectId: projectId,
        entities: tags,
        close: close,
    }))) : ((actions === "unDelete") ? ((tags_1 = map_1((Item_1) => (new DomainEntity(8, [Item_1])), selectedTags), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: tags_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    }))))))))))))))) : undefined);
}

